import { render, staticRenderFns } from "./CaseSidepanel.vue?vue&type=template&id=42b1e0f7&scoped=true&"
import script from "./CaseSidepanel.vue?vue&type=script&lang=js&"
export * from "./CaseSidepanel.vue?vue&type=script&lang=js&"
import style0 from "./CaseSidepanel.vue?vue&type=style&index=0&id=42b1e0f7&lang=scss&scoped=true&"
import style1 from "./CaseSidepanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b1e0f7",
  null
  
)

export default component.exports